import { render, staticRenderFns } from "./V2Pagination.vue?vue&type=template&id=adae6462&scoped=true&"
import script from "./V2Pagination.vue?vue&type=script&lang=js&"
export * from "./V2Pagination.vue?vue&type=script&lang=js&"
import style0 from "./V2Pagination.vue?vue&type=style&index=0&id=adae6462&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adae6462",
  null
  
)

export default component.exports